import { VHCRecordCheckItemInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type SaveDefaultItemInput = {
  logId: number;
  requestBody?: VHCRecordCheckItemInput;
};

export const useSaveDefaultItemMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.postVhcRecordsItemsChecks, SaveDefaultItemInput>
) =>
  useMutationWithNotifications(
    ({ logId, requestBody }: SaveDefaultItemInput) => VhcRecordLogService.postVhcRecordsItemsChecks(logId, requestBody),
    options
  );
